import { render, staticRenderFns } from "./qs2-15.vue?vue&type=template&id=ab839ac2&scoped=true&"
import script from "./qs2-15.vue?vue&type=script&lang=js&"
export * from "./qs2-15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab839ac2",
  null
  
)

export default component.exports